import React from 'react'
import { Icon } from '@iconify/react'
import { Box } from '@mui/material'

export default function Iconify({ icon = 'solar:pulse-outline', sx, ...other }) {
    const baseSx = {
        flexShrink: 0,
        width: '24px',
        height: '24px',
        color: (theme) => theme.palette.primary.main,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
    }

    // If icon is a string, it might be either an Iconify id or an image URL/asset
    if (typeof icon === 'string') {
        const isImage = /\.(png|jpe?g|svg|gif|webp)(\?.*)?$/.test(icon) || icon.includes('/')
        if (isImage) {
            return (
                <Box sx={baseSx} {...other} component="span">
                    <img src={icon} alt="icon" style={{ width: baseSx.width, height: baseSx.height, display: 'block' }} />
                </Box>
            )
        }

        return (
            <Box component={Icon} icon={icon} sx={baseSx} {...other} />
        )
    }

    // If icon is a React element (e.g. imported SVG as ReactComponent), render it safely
    if (React.isValidElement(icon)) {
        // clone element to ensure size props/styles are applied
        const cloned = React.cloneElement(icon, {
            style: {
                width: baseSx.width,
                height: baseSx.height,
                ...icon.props.style,
            },
        })
        return (
            <Box sx={baseSx} {...other}>
                {cloned}
            </Box>
        )
    }

    // If icon is a component (function/class), instantiate it
    if (typeof icon === 'function') {
        const IconComp = icon
        return (
            <Box sx={baseSx} {...other}>
                <IconComp style={{ width: baseSx.width, height: baseSx.height }} />
            </Box>
        )
    }

    // Fallback: render nothing
    return null
}
